import { useQuery } from '@apollo/client';
import { GET_JOB_APPLICATION_DETAIL } from '@gql/jobs';

export const useGetJobApplicationDetail = (id: string | undefined) => {
    const { data, loading, error, refetch } = useQuery(GET_JOB_APPLICATION_DETAIL, {
        variables: { id },
        skip: !id,
    });

    return {
        application: data?.getJobApplication ?? null,
        loading,
        error,
        refetch,
    };
};
